exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3X7Qh{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none}[data-view-mode=editor] ._3X7Qh{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] ._3X7Qh,[data-view-mode=site] ._3X7Qh{background-color:-wix-colors-emptyPlayerBgSite}._3X7Qh ._34hzq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:51px;height:51px;border:1px solid transparent;border-radius:50%;font-size:22px}[data-view-mode=editor] ._3X7Qh ._34hzq{border-color:-wix-colors-emptyPlayIconEditor;color:-wix-colors-emptyPlayIconEditor}[data-view-mode=preview] ._3X7Qh ._34hzq,[data-view-mode=site] ._3X7Qh ._34hzq{border-color:-wix-colors-emptyPlayIconSite;color:-wix-colors-emptyPlayIconSite}._3X7Qh ._34hzq:before{transform:translate(3px,1px)}", ""]);

// exports
exports.locals = {
	"no-videos": "_3X7Qh",
	"noVideos": "_3X7Qh",
	"play": "_34hzq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/no-content/no-videos-content/no-videos-content.styl
// module id = 2395
// module chunks = mobile/mobile widget/strip widget/classic widget/compact